import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupK4 } from '../../../../../../../redux/app/annex6-v2/groups/group-k';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupK4PreviewProps = OwnProps;

function Annex6V2GroupK4Preview(props: Annex6V2GroupK4PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupK4;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemK4P1 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'K', '5', renderItemP1()],
            [null, null, 'NOTE', record.remarks],
        ];

        if (record.remarks) {
            tableRows.push();
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        return (
            <h4 className="font-medium uppercase">
                EGCS made operational on {itemK4P1.date} at {itemK4P1.time}(SMT)
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupK4Preview;
